export const uploadProduct = async ({ product, request }) => {
  const newProduct = product;
  const addProductUrl = request.url;
  const method = request.method;
  const successMessage = request.message;
  const token = request.token;

  try {
    const responseProduct = await fetch(addProductUrl, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newProduct),
    });

    const dataProduct = await responseProduct.json();
    if (!responseProduct.ok) {
      throw new Error(dataProduct.message);
    } else {
      return {
        success: true,
        message: successMessage,
      };

      /// close addModal
    }
  } catch (err) {
    return {
      success: false,
      message: err.message,
    };
  }
};
